import en from './en-GB'
import fr from './fr-FR'

export default {
  fr,
  en,
}
